
import { throwError as observableThrowError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';

@Injectable()

export class UploadService2 {
    constructor(public http: Http) { }

    get(url): Promise<any> {
        return this.http.get(url).pipe(map(response => {
            return response.json() || { success: false, message: "No response from server" };
        }), catchError((error: Response | any) => {
            return observableThrowError(error.json());
        }),).toPromise();
    }

    post(abc: string, data: any): Promise<any> {
        let url = `${environment.api.uploadUrl}`;
        let headers = new Headers();
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return this.http.post(url, data).pipe(map(response => {
            return response || { success: false, message: "No response from server" };
        }), catchError((error: Response | any) => {
            return observableThrowError(error);
        }),).toPromise();
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }
}
